import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import VisibilityIcon from "../../../Icons/VisibilityIcon";
import ListItemText from "@mui/material/ListItemText";

import Context from "../../context";
const CustomizedListItemButton = styled(ListItemButton)`
    color: ${(props) => (props.isActive ? "green" : "")};

    :hover {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
    :active {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
`;

const CustomizedIcon = styled(VisibilityIcon)`
    color: ${(props) => (props.isActive ? "green" : "")};

    :hover {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
    :active {
        color: ${(props) => (props.isActive ? "green" : "")};
    }
`;

export default function VisibilityButton() {
    const { mapMode, setMapMode } = useContext(Context);

    const isActive = mapMode === "visibility";
    return (
        <CustomizedListItemButton
            button
            isActive={isActive}
            // divider
            // className={styles.isSetSurfReport}
            onClick={() => setMapMode("visibility")}
        >
            <ListItemIcon>
                <CustomizedIcon isActive={isActive} />
            </ListItemIcon>
            <ListItemText primary={`Visibility`} />
        </CustomizedListItemButton>
    );
}
